'use es6';

import { merge } from 'rxjs/observable/merge';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { NAVIGATED_TO_EXTERNAL_PAGE } from '../actions/ActionTypes';
import { receiveContent } from '../actions/ContentActions';
import Content from '../models/Content';
export default (action$ => action$.ofType(NAVIGATED_TO_EXTERNAL_PAGE).pipe(mergeMap(({
  payload: {
    title,
    url
  }
}) => merge(of(receiveContent(Content.fromExternalPageJS({
  title,
  url: [url]
})))))));